"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPropertySearchResults = void 0;
var domain_1 = require("@genoa/domain");
exports.mockPropertySearchResults = [
    {
        integration_type: domain_1.IntegrationType.YARDI,
        biller_property_id: '102',
        pmc_id: 'flex-dev-non-sandbox',
        property_id: 'flex01',
        property_name: 'Flex Test Property 1',
        address_line_1: '100 West Channel Road',
        address_line_2: '',
        city: 'Santa Monica',
        state: 'CA',
        postal_code: '90402',
    },
    {
        integration_type: domain_1.IntegrationType.REALPAGE,
        biller_property_id: '1',
        pmc_id: '4593629',
        property_id: '4593630',
        property_name: 'Meadowbrook',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        integration_type: domain_1.IntegrationType.PORTAL,
        biller_property_id: '22',
        pmc_id: 'ReallyCool',
        property_id: 'testpublic55',
        property_name: 'Test Property',
        address_line_1: '123 main st',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
    },
    {
        integration_type: domain_1.IntegrationType.PORTAL,
        biller_property_id: '112',
        pmc_id: 'bv2a7004bfc82844606a83801226ccbad48',
        property_id: 'bv2c5eee9786264478cb83cbdee36302cd8',
        property_name: 'clickpay[Generic Portal]',
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60604',
    },
];
